import { useJsApiLoader } from '@react-google-maps/api';

const GOOGLE_MAPS_API_KEY = 'AIzaSyACQWElIyO28PnfYAXaSgy5Kfh0mnZ-KDM';
const GOOGLE_MAPS_LIBRARIES: ('places' | 'drawing')[] = ['places', 'drawing'];

// Pinned: Google removed DrawingManager (drawing library) from Maps JS v3.65+, which
// crashes the boundary drawers (RegionBoundaryDrawer, TerritoryEditorMap). 3.64 is the
// last version that ships it. When Google retires 3.64 the drawers must be rebuilt
// without DrawingManager — see https://developers.google.com/maps/deprecations
const GOOGLE_MAPS_VERSION = '3.64';

export function useGoogleMaps() {
  return useJsApiLoader({
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    version: GOOGLE_MAPS_VERSION,
    libraries: GOOGLE_MAPS_LIBRARIES,
  });
}
